import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WalletInfo, WalletTransaction } from "td_server/services";

export interface WalletState {
  balance: number;
  totalAdded: number;
  totalSpent: number;
  updatedAt: string | null;
  transactions: WalletTransaction[];
  isLoading: boolean;
  isTransactionsLoading: boolean;
  isRecharging: boolean;
  isModalOpen: boolean;
  activeTab: number; // 0: Recharge, 1: History
  error: string | null;
}

const initialState: WalletState = {
  balance: 0,
  totalAdded: 0,
  totalSpent: 0,
  updatedAt: null,
  transactions: [],
  isLoading: false,
  isTransactionsLoading: false,
  isRecharging: false,
  isModalOpen: false,
  activeTab: 0,
  error: null,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setWalletModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<number>) => {
      state.activeTab = action.payload;
    },
    setWalletInfo: (state, action: PayloadAction<Partial<WalletInfo>>) => {
      state.balance = action.payload?.balance ?? state.balance;
      state.totalAdded = action.payload?.totalAdded ?? state.totalAdded;
      state.totalSpent = action.payload?.totalSpent ?? state.totalSpent;
      state.updatedAt = action.payload?.updatedAt ?? state.updatedAt;
    },
    setWalletBalance: (state, action: PayloadAction<number>) => {
      state.balance = action.payload;
    },
    setTransactions: (state, action: PayloadAction<WalletTransaction[]>) => {
      state.transactions = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setTransactionsLoading: (state, action: PayloadAction<boolean>) => {
      state.isTransactionsLoading = action.payload;
    },
    setRecharging: (state, action: PayloadAction<boolean>) => {
      state.isRecharging = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetWallet: (state) => {
      state.balance = 0;
      state.totalAdded = 0;
      state.totalSpent = 0;
      state.updatedAt = null;
      state.transactions = [];
      state.isLoading = false;
      state.isTransactionsLoading = false;
      state.isRecharging = false;
      state.isModalOpen = false;
      state.activeTab = 0;
      state.error = null;
    },
  },
});

export const {
  setWalletModalOpen,
  setActiveTab,
  setWalletInfo,
  setWalletBalance,
  setTransactions,
  setLoading,
  setTransactionsLoading,
  setRecharging,
  setError,
  resetWallet,
} = walletSlice.actions;

export default walletSlice.reducer;
